<template>
  <div>
    <GameSettingTitle :input="value" @handleSaveDraft="handleSaveDraft" />
    <GameSettingTab :value="view" :input="value" @handleChangeView="handleChangeView" />
    <div class="z-border-red pa-2 pt-4">
      <v-layout wrap>
        <v-flex xs12 sm6>
          <v-btn
            class="mx-0"
            color="primary"
            :outline="showAdvanceSearch"
            @click="showAdvanceSearch = !showAdvanceSearch"
          >
            <v-icon class="mr-2">manage_search </v-icon>
            {{ $t('advanced search') }}
          </v-btn>
        </v-flex>
        <v-flex xs12 sm6 class="text-xs-right">
          <v-btn outline class="mx-0" color="primary" @click="handleDownloadTemplate">
            <v-icon class="mr-2">download</v-icon> {{ $t('Download Template') }}
          </v-btn>

          <v-btn outline class="mx-0" color="primary" @click="handleExport">
            <v-icon class="mr-2">download</v-icon> {{ $t('Export') }}
          </v-btn>

          <importxlsx
            :loading="importLoading"
            :use-format-date="true"
            format-date="DD-MM-YYYY"
            @onChange="handleImport"
          >
            <template #default="{ loading, onClickUploadButton }">
              <v-btn
                :loading="loading"
                outline
                class="mx-0"
                color="primary"
                @click="onClickUploadButton"
              >
                <v-icon class="mr-2">upload</v-icon> {{ $t('IMPORT') }}
              </v-btn>
            </template>
          </importxlsx>
        </v-flex>
      </v-layout>

      <div
        v-if="showAdvanceSearch"
        class="pa-2 my-2"
        style="border: 1px solid #eee; border-radius: 10px"
      >
        <v-layout wrap>
          <v-flex xs12 sm3 class="px-1">
            <div class="caption mb-2">Code</div>
            <v-text-field
              v-model="filter.code"
              class="default-input"
              outline
              hide-details
              single-line
              placeholder="Code"
            />
          </v-flex>
          <v-flex xs12 sm3 class="px-1">
            <div class="caption mb-2">Description</div>

            <v-text-field
              v-model="filter.description"
              class="default-input"
              outline
              hide-details
              single-line
              placeholder="Description"
            />
          </v-flex>

          <v-flex xs12 sm3 class="px-1">
            <div class="caption mb-2">Status</div>
            <v-select
              v-model="filter.status"
              :items="['All', 'In Pending', 'Redeemed']"
              placeholder="Status"
              outline
              class="default-input"
              hide-details
              dense
              single-line
              clearable
            ></v-select>
          </v-flex>
          <v-flex xs12 sm3 class="px-1">
            <div class="caption mb-2">Privilege</div>

            <v-text-field
              v-model="filter.privilege"
              class="default-input"
              outline
              hide-details
              single-line
              placeholder="Privilege"
            />
          </v-flex>
        </v-layout>

        <v-layout wrap class="mt-2">
          <v-flex xs12 sm3 class="px-1">
            <div class="caption mb-2">Create By</div>
            <v-text-field
              v-model="filter.create_by"
              class="default-input"
              outline
              hide-details
              single-line
              placeholder="Create By"
            ></v-text-field>
          </v-flex>
          <v-flex xs12 sm9>
            <div class="caption mb-2">Create Date</div>
            <v-layout wrap>
              <v-flex xs12 sm6 class="px-1">
                <DatepickerCustomDialog v-model="filter.create_date_from">
                  <template #default="{ computedDate }">
                    <v-text-field
                      class="default-input"
                      outline
                      name="startDate"
                      readonly
                      :value="computedDate"
                      hide-details
                      single-line
                      clearable
                      :placeholder="$t('from')"
                      @click:clear="filter.create_date_from = undefined"
                    ></v-text-field>
                  </template>
                </DatepickerCustomDialog>
              </v-flex>
              <v-flex xs12 sm6 class="px-1">
                <DatepickerCustomDialog v-model="filter.create_date_to">
                  <template #default="{ computedDate }">
                    <v-text-field
                      class="default-input"
                      outline
                      name="startDate"
                      readonly
                      :value="computedDate"
                      hide-details
                      single-line
                      clearable
                      :placeholder="$t('to')"
                      @click:clear="filter.create_date_to = undefined"
                    ></v-text-field>
                  </template>
                </DatepickerCustomDialog>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>

        <div class="text-xs-center text-sm-right mt-2">
          <v-btn outline @click="handleClearSearch">{{ $t('Clear search') }}</v-btn>
          <v-btn color="primary" @click="handleSearch">
            <v-icon class="mr-2">search</v-icon>{{ $t('Search') }}
          </v-btn>
        </div>
      </div>
      <v-data-table
        :headers="headers"
        :pagination.sync="pagination"
        :items="rewards"
        class="mt-2 elevation-1"
        :loading="loading"
      >
        <template #items="props">
          <td>{{ props.item.code }}</td>
          <td>{{ props.item.description }}</td>
          <td style="white-space: nowrap">{{ props.item.status }}</td>
          <td>{{ props.item.privilege }}</td>
          <td>{{ props.item.expire_date | dateFormat('DD-MM-YYYY') }}</td>
          <td>{{ props.item.create_by }}</td>
          <td>{{ props.item.created_timestamp | dateFormat('DD-MM-YYYY') }}</td>
          <td style="white-space: nowrap">
            <v-btn icon outline color="primary" @click="handleEditReward(props.item)">
              <v-icon>edit</v-icon>
            </v-btn>
            <v-btn icon outline color="primary" @click="handleDeleteReward(props.item)">
              <v-icon>delete</v-icon>
            </v-btn>
          </td>
        </template>
      </v-data-table>

      <div class="text-xs-center">
        <v-btn outline color="grey" @click="handleBack">
          {{ $t('Back') }}
        </v-btn>
        <template v-if="value.is_draft == false">
          <v-btn color="primary" @click="handleSubmit()">
            {{ $t('Next') }}
          </v-btn>
        </template>
        <template v-else>
          <v-btn color="green" class="white--text" @click="handlePublish">
            {{ $t('Publish') }}
          </v-btn>
        </template>
      </div>

      <template v-if="currentReward">
        <Manage
          v-model="showEditReward"
          :reward="currentReward"
          :privileges="privileges"
          @handleSaveReward="handleSaveReward"
        />
      </template>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import DatepickerCustomDialog from '@/components/elements/DatepickerCustomDialog.vue'
import XLSX from 'xlsx'
import importxlsx from '@/components/elements/importxlsx.vue'
import generaliApi from '@/api/generali'
import { handleResponse, handleApiError } from '@/api/util'
import Manage from './Reward/Manage.vue'
import GameSettingTab from './GameSettingTab'
import GameSettingTitle from './GameSettingTitle'
import moment from 'moment'
export default {
  components: {
    DatepickerCustomDialog,
    importxlsx,
    Manage,
    GameSettingTab,
    GameSettingTitle
  },
  inject: ['$validator'],
  props: ['value', 'view'],
  data() {
    return {
      showAdvanceSearch: false,
      filter: {
        code: null,
        sort_by: null,
        order_by: null,
        limit: null,
        offset: null,
        description: null,
        privilege: null,
        status: null,
        create_by: null,
        create_date_from: null,
        create_date_to: null
      },
      currentReward: null,
      showEditReward: false,
      headers: [
        { value: 'code', text: 'Code' },
        { value: 'description', text: 'Description' },
        { value: 'status', text: 'Status' },
        { value: 'privilege', text: 'Privilege' },
        { value: 'expire_date', text: 'Expire Date' },
        { value: 'create_by', text: 'Create by' },
        { value: 'created_timestamp', text: 'Created date' },
        { text: 'Action', sortable: false }
      ],
      pagination: null,
      rewards: [],
      importLoading: false,
      limit: 15,
      pageNumber: 1,
      total: 0,
      loading: false,
      privileges: []
    }
  },
  computed: {
    ...mapGetters(['selectedBot'])
  },
  watch: {
    pagination: {
      handler() {
        this.handleGetReward()
      },
      deep: true
    }
  },
  async mounted() {
    await this.handleGetPrivilege()
  },
  methods: {
    async handleSaveDraft() {
      this.$emit('handleSaveDraft')
    },
    async handleChangeView(view) {
      const vm = this
      vm.handleSubmit(() => {
        vm.$emit('handleSubmit', { view: view })
      })
    },
    handleSaveReward() {
      this.handleGetReward()
    },
    async handleGetPrivilege() {
      try {
        const response = await generaliApi.getPrivileges({
          config: {
            params: {
              campaign_id: this.value.id
            }
          }
        })
        await handleResponse(response)
        if (response.data.data.length) {
          this.privileges = response.data.data
        }
      } catch (error) {
        handleApiError(error)
      }
    },
    handleBack() {
      this.$emit('handleSubmit', { step: 3 })
    },
    async handlePublish() {
      const result = await this.$validator.validateAll()
      if (!result) {
        // do stuff if not valid.
        this.goToErrorInput()
        return false
      }
      const resultSwal = await this.$swal.fire({
        type: 'warning',
        title: 'เมื่อ Campaign Public แล้วจะไม่สามารถเปลี่ยนเกมส์ได้!',
        showCancelButton: true,
        confirmButtonText: this.$t('Confirm'),
        cancelButtonText: this.$t('cancel'),
        reverseButtons: true
      })
      if (resultSwal.value) {
        this.$emit('handleSubmit', { step: 6, data: { ...this.value, is_draft: false } })
      }
    },
    async handleSubmit(callback) {
      const result = await this.$validator.validateAll()
      if (!result) {
        // do stuff if not valid.
        this.goToErrorInput()
        return false
      }
      if (callback) {
        callback()
      } else {
        this.$emit('handleSubmit', { step: 5 })
      }
    },
    handleEditReward(reward) {
      this.currentReward = reward
      this.showEditReward = true
    },
    async handleDeleteReward(reward) {
      // TODO unable to remove reward
      const result = await this.$swal.fire({
        title: this.$t('Do you want to delete this?'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('Confirm'),
        cancelButtonText: this.$t('cancel'),
        reverseButtons: true
      })
      if (result.value) {
        try {
          const response = await generaliApi.deleteReward({
            config: {
              params: {
                page_id: this.selectedBot.pageid,
                campaign_id: this.value.id
              }
            },
            codeId: reward.id
          })
          await handleResponse(response)
          await this.handleGetReward()
          await this.$swal.fire({
            type: 'success',
            title: this.$t('Success')
          })
        } catch (error) {
          handleApiError(error)
        }
      }
    },
    async handleGetReward() {
      this.loading = true
      try {
        const { sortBy, descending, page, rowsPerPage } = this.pagination
        const response = await generaliApi.getReward({
          config: {
            params: {
              campaign_id: this.value.id,
              page_id: this.selectedBot.pageid,
              ...this.filter,
              status:
                this.filter.status && this.filter.status != 'All' ? this.filter.status : undefined,
              ...(rowsPerPage != -1
                ? {
                    limit: this.limit,
                    offset: (page - 1) * rowsPerPage
                  }
                : {}),
              sort_by: sortBy,
              order_by: descending ? 'desc' : 'asc'
            }
          }
        })
        await handleResponse(response)

        this.total = response.data.total ? response.data.total : 0
        this.rewards = response.data.data ? response.data.data : []
      } catch (error) {
        handleApiError(error)
      }
      this.loading = false
    },
    handleSearch() {
      this.handleGetReward()
    },
    handleClearSearch() {
      this.filter = {
        code: null,
        sort_by: null,
        order_by: null,
        limit: null,
        offset: null,
        description: null,
        privilege: null,
        status: null,
        create_by: null,
        create_date_from: null,
        create_date_to: null
      }
      this.handleGetReward()
    },
    handleExport() {
      let json = []
      if (this.rewards.length) {
        json = this.rewards.map((reward) => ({
          code: reward.code,
          description: reward.description,
          privilege: reward.privilege,
          'Expire date (DD-MM-YYYY)': reward.expire_date
            ? moment(reward.expire_date).format('DD-MM-YYYY')
            : ''
        }))
      } else {
        json.push({
          code: null,
          description: null,
          privilege: null,
          'Expire date (DD-MM-YYYY)': null
        })
      }
      const dataWS = XLSX.utils.json_to_sheet(json)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, dataWS)
      XLSX.writeFile(wb, 'reward-table.xlsx')
    },
    transformHeaderField(data) {
      try {
        return data.map((item) => {
          const tempItem = {
            ...item
          }
          console.log(item)

          Object.keys(item).forEach((element) => {
            switch (element) {
              case 'Expire date (DD-MM-YYYY)':
                console.log(element, item[element])
                tempItem.expire_date = item[element]
                break
              default:
              // code block
            }
          })
          return tempItem
        })
      } catch (error) {
        console.error(error)
        return []
      }
    },
    handleDownloadTemplate() {
      let json = []
      json.push({
        code: null,
        description: null,
        privilege: null,
        'Expire date (DD-MM-YYYY)': null
      })

      const dataWS = XLSX.utils.json_to_sheet(json)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, dataWS)
      XLSX.writeFile(wb, 'reward-template-table.xlsx')
    },
    async handleImport(item) {
      this.importloading = true
      var data = {
        page_id: this.selectedBot.pageid,
        campaign_id: this.value.id,
        codes: this.transformHeaderField(item[0])
      }
      try {
        const response = await generaliApi.importCodes({
          config: {},
          data: data
        })
        await handleResponse(response)
        await this.$swal.fire({
          text: 'สำเร็จ',
          type: 'success'
        })
        await this.handleGetReward()
      } catch (error) {
        console.error(error)
        const message = (error.response && error.response.data && error.response.data.message) || ''
        await this.$swal.fire({
          type: 'error',
          title: 'ข้อมูลไม่ถูกต้อง',
          text: message
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/generalixwarroom/GameSetting/Reward.vue